import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";
import { Station } from "src/app/shared/models/focusDataModels/Station";
import { License } from "src/app/shared/models/license.model";
import { PrinterDeviceItem } from "src/app/shared/models/PrinterDevice.model";

@Component({
	selector: "app-printer-device-setup",
	templateUrl: "./printer-device-setup.component.html",
	styleUrls: ["../../../../commandcenter.scss"],
})
export class PrinterDeviceSetupComponent implements OnInit {
	@Input() printerDeviceSelected: PrinterDeviceItem;
	@Output() printerDeviceSelectedChange = new EventEmitter<PrinterDeviceItem>();

	@Input() posStationList: Station[];
	@Output() posStationListChange = new EventEmitter<Station[]>();

	@Input() kitchenDeviceList: License[];

	changesToSave: boolean = false;

	availablePrinterId: {
		label: string;
		value: number;
		disabled: boolean;
	}[] = [];

	constructor(public app: AppService, private focuslink: FocuslinkService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		this.venueService.subscriptionVenueKey.subscribe((data) => {
			if (data && data !== 0) {
				this.licenseGet(data);
			}
		});
	}

	async licenseGet(venueKey: number) {
		const resp = await this.focuslink.licensesGetByVenue(venueKey, "kitchen-device");
		this.kitchenDeviceList = resp.map((i) => {
			const l = new License(i);
			if (this.venueService.subscriptionVenue.value.status?.kitchenStatus) {
				l.lastHeartbeat = this.venueService.subscriptionVenue.value.status.kitchenStatus.find((x) => x.deviceId === i.printerId)?.lastPulse;
			}
			return l;
		});

		this.availablePrinterIdGenerate();
	}

	availablePrinterIdGenerate() {
		for (let i = 1; i < 33; i++) {
			const inUseLicense = this.kitchenDeviceList.find((lic) => lic.printerId === i);
			this.availablePrinterId.push({
				label: inUseLicense ? inUseLicense.name : i.toString(),
				value: +i,
				disabled: inUseLicense ? true : false,
			});
		}
	}

	setControllingDevice() {
		this.printerDeviceSelected.controllingPosDeviceName = this.posStationList.find((i) => i.ID === this.printerDeviceSelected.controllingPosDeviceId)?.Name;
	}

	async onDelete() {
		this.app.confirmation.confirm({
			message: `Are you sure you want to delete ${this.printerDeviceSelected.name}?`,
			accept: async () => {
				await this.focuslink.printerDeviceDelete(this.venueService.venueKey, this.printerDeviceSelected.sk);
				this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `Printer ${this.printerDeviceSelected.name} deleted` });
				this.printerDeviceSelectedChange.emit(undefined);
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}

	async onSave() {
		this.focuslink.printerDevicePost(this.venueService.venueKey, this.printerDeviceSelected);
		this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `Printer saved successfully` });
		this.printerDeviceSelectedChange.emit(undefined);
	}
}
